import script from "./AppRoot.vue?vue&type=script&setup=true&lang=ts"
export * from "./AppRoot.vue?vue&type=script&setup=true&lang=ts"

import "./AppRoot.vue?vue&type=style&index=0&id=787470d7&lang=scss&scoped=true"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-787470d7"]])

export default __exports__